import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// UI Components
import BlockUi from "react-block-ui";

const BlockUI = (props: any) => {
  const [isBlocking, setIsBlocking] = useState(false);

  useEffect(() => {
    setIsBlocking(props.globals.block_ui);
  }, [props.globals.block_ui]);

  return (
    <BlockUi tag="div" blocking={isBlocking}>
      {props.children}
    </BlockUi>
  );
};

BlockUI.propTypes = {
  globals: PropTypes.object.isRequired,
};

const mapStateToProps = (state: any) => ({
  globals: state.globals,
});

export default connect(mapStateToProps)(BlockUI);
